/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddExamDayParticipantRequestDto } from '../models';
// @ts-ignore
import type { AddExamDayParticipantsBulkRequestDto } from '../models';
// @ts-ignore
import type { AvailableParticipantsResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ParticipantExamSummaryStatusDto } from '../models';
/**
 * ExamDayParticipantApi - axios parameter creator
 * @export
 */
export const ExamDayParticipantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add participant to exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {AddExamDayParticipantRequestDto} addExamDayParticipantRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExamDayParticipant: async (certificationId: number, stageId: number, examDayId: string, addExamDayParticipantRequestDto: AddExamDayParticipantRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addExamDayParticipant', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addExamDayParticipant', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('addExamDayParticipant', 'examDayId', examDayId)
            // verify required parameter 'addExamDayParticipantRequestDto' is not null or undefined
            assertParamExists('addExamDayParticipant', 'addExamDayParticipantRequestDto', addExamDayParticipantRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addExamDayParticipantRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add multiple participants to exam day (bulk, single transaction)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {AddExamDayParticipantsBulkRequestDto} addExamDayParticipantsBulkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExamDayParticipantsBulk: async (certificationId: number, stageId: number, examDayId: string, addExamDayParticipantsBulkRequestDto: AddExamDayParticipantsBulkRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addExamDayParticipantsBulk', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addExamDayParticipantsBulk', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('addExamDayParticipantsBulk', 'examDayId', examDayId)
            // verify required parameter 'addExamDayParticipantsBulkRequestDto' is not null or undefined
            assertParamExists('addExamDayParticipantsBulk', 'addExamDayParticipantsBulkRequestDto', addExamDayParticipantsBulkRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/participants/bulk`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addExamDayParticipantsBulkRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns stage participants NOT assigned to this exam day. 
         * @summary List available participants for exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Search by first name, last name or employee ID (SAP)
         * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by exam status (CSV)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamDayAvailableParticipants: async (certificationId: number, stageId: number, examDayId: string, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamDayAvailableParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamDayAvailableParticipants', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('getExamDayAvailableParticipants', 'examDayId', examDayId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/available-participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (examStatus) {
                localVarQueryParameter['examStatus'] = examStatus.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes participant from exam day. If participant has a DRAFT exam, the exam is also deleted. Cannot remove if exam status is not DRAFT. 
         * @summary Remove participant from exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExamDayParticipant: async (certificationId: number, stageId: number, examDayId: string, participantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('removeExamDayParticipant', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('removeExamDayParticipant', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('removeExamDayParticipant', 'examDayId', examDayId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('removeExamDayParticipant', 'participantId', participantId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/participants/{participantId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamDayParticipantApi - functional programming interface
 * @export
 */
export const ExamDayParticipantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamDayParticipantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add participant to exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {AddExamDayParticipantRequestDto} addExamDayParticipantRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addExamDayParticipant(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantRequestDto: AddExamDayParticipantRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addExamDayParticipant(certificationId, stageId, examDayId, addExamDayParticipantRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayParticipantApi.addExamDayParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add multiple participants to exam day (bulk, single transaction)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {AddExamDayParticipantsBulkRequestDto} addExamDayParticipantsBulkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addExamDayParticipantsBulk(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantsBulkRequestDto: AddExamDayParticipantsBulkRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addExamDayParticipantsBulk(certificationId, stageId, examDayId, addExamDayParticipantsBulkRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayParticipantApi.addExamDayParticipantsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns stage participants NOT assigned to this exam day. 
         * @summary List available participants for exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Search by first name, last name or employee ID (SAP)
         * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by exam status (CSV)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamDayAvailableParticipants(certificationId: number, stageId: number, examDayId: string, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamDayAvailableParticipants(certificationId, stageId, examDayId, page, pageSize, search, examStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayParticipantApi.getExamDayAvailableParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes participant from exam day. If participant has a DRAFT exam, the exam is also deleted. Cannot remove if exam status is not DRAFT. 
         * @summary Remove participant from exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeExamDayParticipant(certificationId: number, stageId: number, examDayId: string, participantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeExamDayParticipant(certificationId, stageId, examDayId, participantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayParticipantApi.removeExamDayParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamDayParticipantApi - factory interface
 * @export
 */
export const ExamDayParticipantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamDayParticipantApiFp(configuration)
    return {
        /**
         * 
         * @summary Add participant to exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {AddExamDayParticipantRequestDto} addExamDayParticipantRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExamDayParticipant(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantRequestDto: AddExamDayParticipantRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addExamDayParticipant(certificationId, stageId, examDayId, addExamDayParticipantRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add multiple participants to exam day (bulk, single transaction)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {AddExamDayParticipantsBulkRequestDto} addExamDayParticipantsBulkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExamDayParticipantsBulk(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantsBulkRequestDto: AddExamDayParticipantsBulkRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addExamDayParticipantsBulk(certificationId, stageId, examDayId, addExamDayParticipantsBulkRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns stage participants NOT assigned to this exam day. 
         * @summary List available participants for exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Search by first name, last name or employee ID (SAP)
         * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by exam status (CSV)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamDayAvailableParticipants(certificationId: number, stageId: number, examDayId: string, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig): AxiosPromise<AvailableParticipantsResponseDto> {
            return localVarFp.getExamDayAvailableParticipants(certificationId, stageId, examDayId, page, pageSize, search, examStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes participant from exam day. If participant has a DRAFT exam, the exam is also deleted. Cannot remove if exam status is not DRAFT. 
         * @summary Remove participant from exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExamDayParticipant(certificationId: number, stageId: number, examDayId: string, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeExamDayParticipant(certificationId, stageId, examDayId, participantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamDayParticipantApi - interface
 * @export
 * @interface ExamDayParticipantApi
 */
export interface ExamDayParticipantApiInterface {
    /**
     * 
     * @summary Add participant to exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {AddExamDayParticipantRequestDto} addExamDayParticipantRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApiInterface
     */
    addExamDayParticipant(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantRequestDto: AddExamDayParticipantRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Add multiple participants to exam day (bulk, single transaction)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {AddExamDayParticipantsBulkRequestDto} addExamDayParticipantsBulkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApiInterface
     */
    addExamDayParticipantsBulk(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantsBulkRequestDto: AddExamDayParticipantsBulkRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns stage participants NOT assigned to this exam day. 
     * @summary List available participants for exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Search by first name, last name or employee ID (SAP)
     * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by exam status (CSV)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApiInterface
     */
    getExamDayAvailableParticipants(certificationId: number, stageId: number, examDayId: string, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig): AxiosPromise<AvailableParticipantsResponseDto>;

    /**
     * Removes participant from exam day. If participant has a DRAFT exam, the exam is also deleted. Cannot remove if exam status is not DRAFT. 
     * @summary Remove participant from exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApiInterface
     */
    removeExamDayParticipant(certificationId: number, stageId: number, examDayId: string, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ExamDayParticipantApi - object-oriented interface
 * @export
 * @class ExamDayParticipantApi
 * @extends {BaseAPI}
 */
export class ExamDayParticipantApi extends BaseAPI implements ExamDayParticipantApiInterface {
    /**
     * 
     * @summary Add participant to exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {AddExamDayParticipantRequestDto} addExamDayParticipantRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApi
     */
    public addExamDayParticipant(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantRequestDto: AddExamDayParticipantRequestDto, options?: RawAxiosRequestConfig) {
        return ExamDayParticipantApiFp(this.configuration).addExamDayParticipant(certificationId, stageId, examDayId, addExamDayParticipantRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add multiple participants to exam day (bulk, single transaction)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {AddExamDayParticipantsBulkRequestDto} addExamDayParticipantsBulkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApi
     */
    public addExamDayParticipantsBulk(certificationId: number, stageId: number, examDayId: string, addExamDayParticipantsBulkRequestDto: AddExamDayParticipantsBulkRequestDto, options?: RawAxiosRequestConfig) {
        return ExamDayParticipantApiFp(this.configuration).addExamDayParticipantsBulk(certificationId, stageId, examDayId, addExamDayParticipantsBulkRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns stage participants NOT assigned to this exam day. 
     * @summary List available participants for exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Search by first name, last name or employee ID (SAP)
     * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by exam status (CSV)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApi
     */
    public getExamDayAvailableParticipants(certificationId: number, stageId: number, examDayId: string, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig) {
        return ExamDayParticipantApiFp(this.configuration).getExamDayAvailableParticipants(certificationId, stageId, examDayId, page, pageSize, search, examStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes participant from exam day. If participant has a DRAFT exam, the exam is also deleted. Cannot remove if exam status is not DRAFT. 
     * @summary Remove participant from exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayParticipantApi
     */
    public removeExamDayParticipant(certificationId: number, stageId: number, examDayId: string, participantId: number, options?: RawAxiosRequestConfig) {
        return ExamDayParticipantApiFp(this.configuration).removeExamDayParticipant(certificationId, stageId, examDayId, participantId, options).then((request) => request(this.axios, this.basePath));
    }
}

